import React from 'react'
import PropTypes from 'prop-types'

import BasePureComponent from 'utils/BasePureComponent'

import './style.scss'


const _renderErrors = (errors) => {
  const _renderError = (error, idx) => <li key={idx}>{error}</li>
  const hasErrors =  errors.length > 0

  return hasErrors ? (
    <ul className="errors-list">
      {errors.map(_renderError)}
    </ul>
  ) : null
}

const _renderLabel = (label, textAreaId) => ( !!label ? <label htmlFor={textAreaId}>{label}</label> : null )



export default class TextArea extends BasePureComponent {
  render() {
    // extract invalid props for HTML <textarea />
    const {errors, id, label, size, className: textAreaClass, ...textAreaProps} = this.props
    const hasErrors =  errors.length > 0

    const errorClass = hasErrors ? 'has-error' : ''
    const sizeClass = size || ''
    const textAreaId = id || `id_${textAreaProps.name}`

    return (
      <div className={`TextArea ${errorClass} ${sizeClass}`}>
        {_renderLabel(label, textAreaId)}
        <textarea className={`form-control ${textAreaClass}`}
                  {...textAreaProps}
                  id={textAreaId}
                  ref={(textArea) => this.textArea = textArea}></textarea>
        {_renderErrors(errors)}
      </div>
    )
  }
}

TextArea.defaultProps = {
  errors: [],
  size: null,
  name: null,
  label: null,
  id: null,
  className: '',
}

TextArea.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['big', null]),
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/components/TextArea/index.js